import { Flex, Stack, type StackProps } from '@chakra-ui/react';
import { AuthenticatedRouteItems, UnauthenticatedRouteItems } from '../../routes/AppRouter';
import { SidebarNavItems } from './sidebarNavItems';

interface SidebarProps extends StackProps {
  showAdminNav: boolean;
}

export const Sidebar = (props: SidebarProps) => {
  const { ...rest } = props;

  return (
    <Stack p={'4'} bg='bg.panel' {...rest}>
      <Stack gap='8' width={'224px'}>
        <SidebarNavItems items={[...AuthenticatedRouteItems, ...UnauthenticatedRouteItems]} />
      </Stack>
      <Flex direction={'column'}></Flex>
    </Stack>
  );
};
